<template>
  <div class="box10">
    <pageTitle
      title="20+常用测试工具&nbsp;&nbsp;工作效率大大提高"
      text="测试工具相比手工测试，不仅有更高的效率，更好的一致性、准确性、可靠性，而且它还可以完成很多手工测试无法胜任的任务"
      titleColor="#24375C"
      titColor="#86909C"
    />
    <vue-seamless-scroll
      :data="tabList"
      :class-option="classOption2"
      class="seamless-warp"
    >
      <div class="demo">
        <div class="item" v-for="(item, index) in tabList" :key="index">
          <img :src="item.img" alt="" />
          <b>{{ item.txt }}</b>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    vueSeamlessScroll,
    pageTitle,
  },
  data() {
    return {
      tabList: [
        {
          txt: "自动化开源跨平台工具，支持IOS/Android平台原生应用、Web应用、混合应用。",
          img: require("../../../assets/coursePage/softwareTest/box9/appium.png"),
        },
        {
          txt: "HTTP调试抓包工具，通过代理的方式获取程序HTTP通讯数据，可以编辑修改请求和响应，支持多平台和多浏览器。",
          img: require("../../../assets/coursePage/softwareTest/box9/Fiddlre.png"),
        },
        {
          txt: "开源的分布式版本控制系统，有效、高速处理大中小项目的版本管理，市场占比较高的版本管理工具。",
          img: require("../../../assets/coursePage/softwareTest/box9/git.png"),
        },
        {
          txt: "开源软件项目，基于Java开发的持续集成工具，可以处理任何类型的构建或持续集成，目前主流的企业持续集成应用工具。",
          img: require("../../../assets/coursePage/softwareTest/box9/Jenkins.png"),
        },
        {
          txt: "开源的基于Java的压力测试工具，用于对静态和动态对资源进行性能测试。扩展性好、市场主流的性能压测工具。",
          img: require("../../../assets/coursePage/softwareTest/box9/JMeter.png"),
        },
        {
          txt: "流行的关系型数据库管理系统，企业应用广泛、并发能力强、响应速度快，是一款性能较好的数据库软件。",
          img: require("../../../assets/coursePage/softwareTest/box9/MySQL.png"),
        },
        {
          txt: "一款国产开源项目管理软件，支持产品管理、项目管理、质量管理、文档管理，采用基于Scrum设计，市场占比高。",
          img: require("../../../assets/coursePage/softwareTest/box9/chandao.png"),
        },
        {
          txt: "功能强大的网页调试与发送HTTP请求的Chrome插件，支持发送任何类型的HTTP请求、支持不同认证机制、响应数据自动语法高亮。",
          img: require("../../../assets/coursePage/softwareTest/box9/POSTMAN.png"),
        },
        {
          txt: "一款解释型、动态的、面向对象的高级程序设计语言，可用于Web开发、科学计算和统计、自动化测试等领域，目前主流自动化框架均支持。",
          img: require("../../../assets/coursePage/softwareTest/box9/LOCUST.png"),
        },
        {
          txt: "流行的关系型数据库管理系统，企业应用广泛、并发能力强、响应速度快，是一款性能较好的数据库软件。",
          img: require("../../../assets/coursePage/softwareTest/box9/SeleniumHQ.png"),
        },
        {
          txt: "开源Web自动化测试工具，支持主流浏览器，Webdriver协议是业内的浏览器UI测试的标准实现，目前Web自动化测试应用占比较高。",
          img: require("../../../assets/coursePage/softwareTest/box9/Python.png"),
        },
        {
          txt: "功能强大的 API 开发协作平台，集成 API 设计、调试、自动化测试、Mock 服务、团队协作和文档管理等功能。",
          img: require("../../../assets/coursePage/softwareTest/box9/Apifox.png"),
        },
        {
          txt: "华为向HarmonyOS开发者提供的一个综合测试平台，助力开发者在开发、调试和发布过程中高效进行各类测试。",
          img: require("../../../assets/coursePage/softwareTest/box9/DevEcoTesting.png"),
        },
      ],
    };
  },

  computed: {
    classOption2() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .course-text {
  padding: 0 36px;
}
.box10 {
  position: relative;

  width: 100%;

  background: url("../../../assets/coursePage/softwareTest/box9/bg.png")
    no-repeat;
  padding: 80px 0 88px;
  background-size: cover;
  background-position: center;

  box-sizing: border-box;
  .titleWrap {
    padding-top: 40px;
  }
  .title {
    width: 620px;
    height: 142px;
    background: url("../../../assets/coursePage/softwareTest/box1/title.png")
      no-repeat;
    background-size: contain;
    background-position: center;
  }
  .content {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #002e77;
    margin: 10px 42px 40px;
  }
  .desc {
    width: 164px;
    height: 48px;
    text-align: center;
    background: linear-gradient(270deg, #3a7dff 0%, #3ca5ff 100%);
    border-radius: 24px;
    border: 2px solid #ffffff;
    // backdrop-filter: blur(5px);

    box-sizing: border-box;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    margin-bottom: 32px;
    margin-left: 42px;
  }
  .seamless-warp {
    margin-top: 28px;
    width: 100%;
    overflow: visible;
    .demo {
      display: flex;
      padding-bottom: 16px;
      padding-top: 20px;
    }
    .item {
      width: 306px;
      height: 418px;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(64,128,255,0.12);
      border-radius: 9px;

      padding: 10px 32px;
      flex-shrink: 0;
      box-sizing: border-box;
      margin: 0 4px 0 28px;
      img {
        display: block;
        width: 184px;
        height: auto;
        margin: 0 auto;
      }
      b {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4b596b;
        text-align: justify;
        display: inline-block;
        line-height: 40px;
      }
    }
    .item:last-child {
      img {
        margin: 9px 0;
        width: 220px;
      }
    }
  }
}
</style>
